<tool-form formTitle="Enrollment and Trends Filter">
  <form
    [formGroup]="transfersForm"
    (ngSubmit)="submitForm()"
    class="form-content"
  >
    <mat-form-field class="filter-form-field">
      <mat-label>Select Admit Type</mat-label>
      <mat-select formControlName="admit_type" required>
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let admitType of dataFilterOptions.admit_types"
          [value]="admitType"
          >{{ admitType }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.transfersForm.controls['admit_type'].invalid"
        >You must select at least an admit type</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Select Associate Degree</mat-label>
      <mat-select formControlName="associate_degree" required>
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let associateDeg of dataFilterOptions.associate_degrees"
          [value]="associateDeg"
          >{{ associateDeg }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.transfersForm.controls['admit_type'].invalid"
        >You must select at least an admit type</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Full/Part-Time Indicator</mat-label>
      <mat-select formControlName="full_part_time_ind" required>
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let ind of dataFilterOptions.full_part_time_inds"
          [value]="ind.value"
          >{{ ind.text }}</mat-option
        >
      </mat-select>
      <mat-error
        *ngIf="this.transfersForm.controls['full_part_time_ind'].invalid"
        >You must select at least an admit type</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Graduation Time</mat-label>
      <mat-select formControlName="graduation_time" required>
        <mat-option
          *ngFor="let ind of dataFilterOptions.graduation_times"
          [value]="ind.value"
          >{{ ind.text }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.transfersForm.controls['graduation_time'].invalid"
        >You must select at least an admit type</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>College</mat-label>
      <mat-select
        formControlName="college"
        required
        (selectionChange)="onCollegeChange()"
      >
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let college of dataFilterOptions.colleges"
          [value]="college"
          >{{ college }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.transfersForm.controls['college'].invalid"
        >You must select a college</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Department</mat-label>
      <mat-select
        formControlName="department"
        required
        (selectionChange)="onDepartmentChange()"
      >
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let dept of dataFilterOptions.departments"
          [value]="dept.name"
          >{{ dept.name }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.transfersForm.controls['department'].invalid"
        >You must select a department</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Program</mat-label>
      <mat-select formControlName="program" required>
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let program of dataFilterOptions.programs"
          [value]="program.name"
          >{{ program.name }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.transfersForm.controls['program'].invalid"
        >You must select a program</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Transfer College Name</mat-label>
      <mat-select formControlName="transfer_college_name" required>
        <mat-option value="all">All</mat-option>
        <mat-option
          *ngFor="let collegeName of dataFilterOptions.transfer_colleges_names"
          [value]="collegeName"
          >{{ collegeName }}</mat-option
        >
      </mat-select>
      <mat-error
        *ngIf="this.transfersForm.controls['transfer_college_name'].invalid"
        >You must select a transfer college name</mat-error
      >
      <progress-bar *ngIf="loadingFilterOptions"></progress-bar>
    </mat-form-field>

    <tool-form-action-button
      text="Submit"
      (onClick)="closeDialog()"
      [disabled]="!transfersForm.valid"
    ></tool-form-action-button>
  </form>
</tool-form>
